import moment from "moment";

const validate = (values = {}) => {
	const errors = {};

	if (!values.name) errors.name = "Informe o nome";

	if (!values.email) errors.email = "Informe o e-mail";

	if (!values.phoneNumber) errors.phoneNumber = "Informe o número de telefone";

	if (!values.role) errors.role = "Selecione uma função";

	if (!values.status) errors.status = "Selecione um status";

	if (values.cpf) {
		const cleaned = values.cpf.replace(/[^0-9A-Za-z]/g, "");
		const isCnpj = /[A-Za-z]/.test(cleaned) || cleaned.length > 11;

		if (isCnpj) {
			if (cleaned.length !== 14) errors.cpf = "CNPJ inválido";
		} else if (cleaned.replace(/\D/g, "").length !== 11) {
			errors.cpf = "Cpf inválido";
		}
	}

	if (
		values.birthDate &&
		moment().diff(moment(values.birthDate, "DD/MM/YYYY"), "years") < 18
	) {
		errors.birthDate = "Data menor que 18 anos";
	}

	if (values.birthDate && !/\d{2}\/\d{2}\/\d{4}/.test(values.birthDate)) {
		errors.birthDate = "Data de nascimento inválida";
	}

	return errors;
};

export default validate;
